import UltMeta, { Meta } from "./UltMeta/index";
/**
 * 活动状态
 */
class ActivityState extends UltMeta {
    DRAFT = new Meta(2, "草稿");   
    ENABLED = new Meta(1, "已开启");
    CLOSED = new Meta(0, "已关闭");
}

export const ACTIVITY_STATE = new ActivityState();

/**
 * 活动状态
 */
class PCActivityState extends UltMeta {
    ENABLED = new Meta(1, "已开启");
    CLOSED = new Meta(0, "已关闭");
}

export const PC_ACTIVITY_STATE = new PCActivityState();

/**
 * 定价方式
 */
class PricingMethod extends UltMeta {
    MARKET_ACTIVITY_PRICE = new Meta(1, "市场价+活动单价");
    MARKET_DROP = new Meta(2, "比市场价直降");
    ACTIVITY_SCENE = new Meta(3, "以活动现场公布为准");
}

export const PRICING_METHOD = new PricingMethod();

/**
 * 是否允许超售
 */
class IsOverbooking extends UltMeta {
    YES = new Meta(1, "是");
    NO = new Meta(0, "否");
}

export const IS_OVERBOOKING = new IsOverbooking();

/**
 * 下单要求
 */
class OrderRequirements extends UltMeta {
    FIXED_AMOUNT = new Meta(1, "固定金额");
    LADDER_AMOUNT = new Meta(2, "阶梯金额");
}

export const ORDER_REQUIREMENTS = new OrderRequirements();

/**
 * 活动类型枚举
 */
class ActivityType extends UltMeta {
    ACTIVITY_REGISTRATION = new Meta(1, "活动报名");
    ACTIVITY_PRODUCT = new Meta(2, "活动商品");
}

export const ACTIVITY_TYPE = new ActivityType();

/**
 * 参会形式配置枚举
 */
class Participation extends UltMeta {
    NAMING_RIGHTS = new Meta(1, "冠名");
    CO_ORGANIZER = new Meta(2, "协办");
    SPONSOR = new Meta(3, "赞助");
    EXHIBITOR = new Meta(4, "参展");
    GENERAL_PARTICIPATION = new Meta(5, "普通参会");
}

export const PARTICIPATION = new Participation();

/**
 * 参会信息 字段配置
 */
class ParticipationInfoField extends UltMeta {
    COMPANY_NAME = new Meta(1, "企业抬头");
    JOB_TITLE = new Meta(2, "职务");
    PERSON_NAME = new Meta(3, "姓名");
    MOBILE = new Meta(4, "手机号");
    PARTICIPATION_REQUIREMENTS = new Meta(5, "参会需求");
}

export const PARTICIPATION_INFO_FIELD = new ParticipationInfoField();

/**
 * 商品类型枚举
 */
class ActivityProductType extends UltMeta {
    CONSIGNMENT_GROUP_BARGAIN = new Meta(1, "关联寄售/团购/捡漏商品");
    ACTIVITY_PRODUCT = new Meta(2, "新增活动商品");
}

export const ACTIVITY_PRODUCT_TYPE = new ActivityProductType();

/**
 * 报名信息状态校举
 */
class CampaignRegistrationState extends UltMeta {
    WAIT_PAY = new Meta(1, "待支付");
    WAIT_CONFIRM_PAY = new Meta(2, "待确认支付");
    REGISTERED = new Meta(3, "已报名");
    CANCELLED = new Meta(4, "已取消");
}

export const CAMPAIGN_REGISTRATION_STATE = new CampaignRegistrationState();

/**
 * 需求对接字段输入类型
 */
class RequirementMatchFieldType extends UltMeta {
    TEXT_INPUT = new Meta(1, "文本框");
    RADIO_BUTTON = new Meta(2, "单选按钮");
    CHECKBOX_BUTTON = new Meta(3, "多选按钮");
    ADDRESS = new Meta(4, "地址");
    DATE_TIME = new Meta(5, "日期时间");
    TEXTAREA = new Meta(6, "多行文本框");
}

export const REQUIREMENT_MATCH_FIELD_TYPE = new RequirementMatchFieldType();
